module.exports = __webpack_public_path__ + "img/create-robot-icon.128fc04a.png";